import { supabase } from './supabase'

export type AdminSupportNotificationType = 'support_email' | 'feedback'

export interface AdminSupportNotificationPayload {
  type: AdminSupportNotificationType
  subject: string
  message: string
  from_email: string
  from_name: string
  record_id: string
  created_at: string
}

export async function notifyAdminSupport(
  payload: AdminSupportNotificationPayload
): Promise<void> {
  const { error } = await supabase.functions.invoke('notify-admin-support', {
    body: payload,
  })

  if (error) {
    throw error
  }
}
